<div class="skeleton-discover-filters-header">
  <div class="skeleton-discover-filters-title"></div>
  <div class="skeleton-discover-filters-navigation">
    <div class="skeleton-discover-filters-navigation-button"></div>
    <div class="skeleton-discover-filters-navigation-button"></div>
  </div>
</div>
<div class="skeleton-discover-filters-container"></div>
